// Environment configuration for CarWash Business OS
const config = {
  // Environment detection
  isDevelopment: import.meta.env.DEV || import.meta.env.VITE_APP_ENV === 'development',
  isProduction: import.meta.env.PROD || import.meta.env.VITE_APP_ENV === 'production',
  
  // Development mode (explicit only). Prefer Firebase emulators for local development.
  devMode: import.meta.env.VITE_DEV_MODE === 'true',
  
  // Emulator mode (for local Firebase emulators)
  useEmulators: import.meta.env.VITE_USE_EMULATORS === 'true',
  
  // Firebase configuration
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
  },
  
  // API endpoints
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001',
    functionsUrl: import.meta.env.VITE_FUNCTIONS_URL || 'http://localhost:5001'
  },
  
  // App configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'CarWash Business OS',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    supportEmail: import.meta.env.VITE_SUPPORT_EMAIL || 'support@carwash.co.za',
    locale: 'en-ZA', // South African English
    currency: 'ZAR',
    timezone: 'Africa/Johannesburg'
  },
  
  // South African specific configuration
  southAfrica: {
    // Phone number format
    phoneFormat: '+27',
    // Business compliance
    vatRate: 0.15, // 15% VAT
    // Common business hours
    businessHours: {
      open: '07:00',
      close: '18:00',
      timezone: 'Africa/Johannesburg'
    },
    // Load shedding schedules integration
    loadsheddingApi: 'https://loadshedding.eskom.co.za/LoadShedding',
    // Local payment methods
    paymentMethods: [
      'cash',
      'card',
      'eft',
      'account',
      'payfast',
      'paygate',
      'ozow',
      'snapscan',
      'debit_order'
    ]
  },
  
  // External services
  services: {
    // Communication
    twilio: {
      accountSid: import.meta.env.VITE_TWILIO_ACCOUNT_SID
    },
    sendgrid: {
      apiKey: import.meta.env.VITE_SENDGRID_API_KEY
    },
    
    // South African SMS providers
    clickatell: {
      apiKey: import.meta.env.VITE_CLICKATELL_API_KEY
    },
    africastalking: {
      apiKey: import.meta.env.VITE_AFRICASTALKING_API_KEY
    },
    
    // Payment gateways
    stripe: {
      publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
    },
    payfast: {
      merchantId: import.meta.env.VITE_PAYFAST_MERCHANT_ID,
      merchantKey: import.meta.env.VITE_PAYFAST_MERCHANT_KEY
    },
    paygate: {
      payGateId: import.meta.env.VITE_PAYGATE_ID,
      secretKey: import.meta.env.VITE_PAYGATE_SECRET
    },
    
    // Analytics
    analytics: {
      googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
    }
  }
}

// Validation for production
if (config.isProduction && !config.devMode) {
  const requiredEnvVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_AUTH_DOMAIN'
  ]
  
  const missingVars = requiredEnvVars.filter(varName => !import.meta.env[varName])
  
  if (missingVars.length > 0) {
    console.error('❌ Missing required environment variables:', missingVars)
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`)
  }
}

// Log configuration status
if (config.devMode) {
  console.log('🔧 Running in Development Mode with Mock Data')
} else {
  console.log('🚀 Running in Production Mode with Firebase')
  console.log(`📊 Project: ${config.firebase.projectId}`)
}

export default config 